const EMPTY_EXPENSE = 'Nhập khoản chi';

export { EMPTY_EXPENSE };
